
/* LMM Predictive Search split layout + bestseller ordering. Draft only. */
(function () {
  'use strict';
  if (window.LMMPredictiveSplitLayout) return;
  window.LMMPredictiveSplitLayout = '2026.07.11-bestseller-2';

  var timer = 0;
  var MAX_INDEX_PAGES = 60;
  /* 4 -> 6 am 13.08.2026: Seit die Raenge aus dem Metafeld custom.bestseller_rank
     kommen, korreliert die Seitenposition (native Best-Selling-Reihenfolge) nicht
     mehr mit dem Rang. Am 13.08.2026 nach der Umstellung auf Option A ueber den
     ECHTEN Clientpfad nachgemessen (26 Seiten, 4.268 ausgelieferte Eintraege):
     4 Seiten decken 99,8 % der Top-500, 6 Seiten 100 % der Top-500 und 97,7 %
     der Top-1000. Kosten: zwei zusaetzliche Section-Anfragen, die sonst ohnehin
     in der Leerlaufstufe kaemen — und die Antworten sind seit dem Wegfall des
     Collections-Payloads (siehe sections/lmm-bestseller-index.liquid) ein
     Bruchteil der bisherigen Groesse. */
  var EAGER_INDEX_PAGES = 6;
  /* Schluessel-Versionssprung. Der Schluesselname ist die EINZIGE Invalidierung
     dieses Caches: es gibt kein TTL und keine Pruefsumme, und eine im
     sessionStorage vermerkte Seite wird in derselben Session nie erneut geholt.
     Ohne Bump mischt ein Bestandsbesucher alte und neue Raenge.
       -2026-08-13-score-v1  Rangquelle von der Positionszahl der Best-Selling-
                             Collection auf das Metafeld custom.bestseller_rank
                             umgestellt (24M-Fenster, damals B2B-gewichtet).
       -2026-08-13-orderfreq-v1  Rangregel auf Option A umgestellt: reine
                             Bestellhaeufigkeit, Stueckzahl nur bei Gleichstand,
                             keine B2B-Gewichtung. 4.257 der 4.272 Raenge haben
                             sich dabei geaendert — ein alter Cache waere fast
                             vollstaendig falsch. */
  /* DATENGETRIEBEN seit 13.08.2026 (Chris-Auftrag Teil 9): Der Schluessel enthaelt den
     RANGSTAND, den der taegliche Refresh in das Shop-Metafeld custom.bestseller_stand
     schreibt und den snippets/lmm-bestseller-sort-inline.liquid als window.LMM_RANGSTAND
     rendert. Damit invalidiert jeder Tageslauf den Cache von selbst — ohne dass je wieder
     eine Theme-Datei angefasst werden muss. Faellt das Metafeld aus, rotiert der Schluessel
     ersatzweise taeglich ueber das Datum; eine Rangliste kann so hoechstens einen Tag
     alt werden statt eine ganze Sitzung lang zu konservieren.
     Das feste Praefix bleibt die STRUKTUR-Version des Cacheformats und wird nur
     hochgezaehlt, wenn sich der Aufbau des gespeicherten Objekts aendert. */
  var RANG_STAND = (typeof window.LMM_RANGSTAND === 'string' && window.LMM_RANGSTAND)
    ? window.LMM_RANGSTAND
    : new Date().toISOString().slice(0, 10);
  var BESTSELLER_CACHE_KEY = 'lmm:bestseller-index:v3:' + RANG_STAND;
  var bestsellerRanks = new Map();
  var categoryStats = new Map();
  var categorySalesUnits = new Map();
  var collectionPageCache = new Map();
  var catalogByHandle = new Map();
  var loadedIndexPages = new Set();
  var lastIndexPage = 0;

  function indexIsComplete() {
    if (!lastIndexPage) return false;
    for (var page = 1; page <= lastIndexPage; page += 1) {
      if (!loadedIndexPages.has(page)) return false;
    }
    return true;
  }
  var indexPagePromises = new Map();
  var idleIndexStarted = false;
  var exactCategoryDataReady = false;
  var indexEventTimer = 0;
  var indexEventOffen = false;
  var indexKomplettGemeldet = false;

  function inputFor(box) {
    var component = box.closest('predictive-search-component');
    return (component && component.querySelector('input[name="q"]')) || document.querySelector('.lmmh-search__form input[name="q"]');
  }

  function previewUrl(path) {
    var target = new URL(path, location.origin);
    var current = new URL(location.href);
    ['preview_theme_id', 'preview_key'].forEach(function (key) {
      if (current.searchParams.has(key) && !target.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    return target;
  }

  function normalizeCategoryTitle(value) {
    var text = String(value || '').toLowerCase()
      .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss');
    if (text.normalize) text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g,'');
    text = text.replace(/(\d)[.,](?=\d{3}(?:\D|$))/g,'$1');
    return text.replace(/&/g,' und ')
      .replace(/[^a-z0-9]+/g,' ')
      .replace(/\b(\d+)\s+(mm|cm|w|v|k)\b/g,'$1$2')
      .replace(/\s+/g,' ').trim();
  }

  function initExactCategoryData() {
    if (exactCategoryDataReady) return;
    exactCategoryDataReady = true;

    try {
      var element = document.querySelector('#lmm-category-sales-data');
      var payload = element ? JSON.parse(element.textContent || '{}') : {};
      var byTitle = new Map();
      (payload.rows || []).forEach(function (row) {
        var title = normalizeCategoryTitle(row[0]);
        var units = Number(row[1] || 0);
        if (title && Number.isFinite(units)) byTitle.set(title, units);
      });

      var engine = window.LMMSearchIntent;
      var catalog = engine && typeof engine.getCatalog === 'function' ? engine.getCatalog() : [];
      catalog.forEach(function (item) {
        if (!item || !item.handle) return;
        catalogByHandle.set(item.handle, item);
        var units = byTitle.get(normalizeCategoryTitle(item.title));
        if (Number.isFinite(units)) categorySalesUnits.set(item.handle, units);
      });
    } catch (error) {
      if (window.console) console.warn('[LMM Predictive] Kategorie-Verkaufsindex konnte nicht gelesen werden.', error);
    }
  }

  function ensureCategoryImage(node, handle) {
    if (!(node instanceof HTMLElement) || !handle) return;
    var item = catalogByHandle.get(handle);
    if (!item || !item.image) return;

    var media = node.querySelector('.lmm-intent-category__media, .lmm-predictive__cat-ico');
    if (!media || media.querySelector('img')) return;

    media.innerHTML = '';
    var image = document.createElement('img');
    image.src = item.image;
    image.alt = '';
    image.width = 64;
    image.height = 64;
    image.loading = 'lazy';
    media.appendChild(image);
  }

  function parseProductId(value) {
    var match = String(value || '').match(/(\d{8,})$/);
    return match ? match[1] : String(value || '');
  }

  /* Deduplizierungsschluessel (Korrekturrunde 3, Chris Phase 10): FUEHREND ist
     die Shopify-Product-ID — dasselbe Produkt darf nicht doppelt erscheinen,
     nur weil es ueber eine collection-gebundene URL nachgeladen wurde. Der
     URL-Pfad bleibt ausschliesslich Rueckfallebene fuer Knoten, die technisch
     keine Product-ID tragen (jeder Rueckfall ist im QA-Bericht dokumentiert). */
  function productKey(node) {
    if (!(node instanceof HTMLElement)) return '';
    var id = node.getAttribute('data-lmm-product-id');
    if (id) {
      var kern = parseProductId(id);
      if (kern) return 'pid:' + kern;
    }
    var explicit = node.getAttribute('data-lmm-product-url');
    if (explicit) return explicit.split('?')[0];
    var link = node.querySelector('a[href*="/products/"]');
    return link ? String(link.getAttribute('href') || '').split('?')[0] : '';
  }

  function productId(node) {
    if (!(node instanceof HTMLElement)) return '';
    return parseProductId(node.getAttribute('data-lmm-product-id'));
  }

  function existingKeys(list) {
    var keys = new Set();
    list.querySelectorAll('.lmm-predictive__prod').forEach(function (node) {
      var key = productKey(node);
      if (key) keys.add(key);
    });
    return keys;
  }

  function saveIndexCache() {
    try {
      var entries = [];
      bestsellerRanks.forEach(function (rank, id) { entries.push([id, rank]); });
      var categories = [];
      categoryStats.forEach(function (stats, handle) { categories.push([handle, stats.score, stats.bestRank, stats.hits]); });
      sessionStorage.setItem(BESTSELLER_CACHE_KEY, JSON.stringify({
        entries: entries,
        categories: categories,
        pages: Array.from(loadedIndexPages),
        lastPage: lastIndexPage
      }));
    } catch (error) { /* cache is optional */ }
  }

  function restoreIndexCache() {
    try {
      var raw = sessionStorage.getItem(BESTSELLER_CACHE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!validIndexEntries(data.entries, true) || !Array.isArray(data.categories)) return;
      if (!Number.isInteger(data.lastPage) || data.lastPage < 0 || data.lastPage > MAX_INDEX_PAGES || !Array.isArray(data.pages) || data.pages.some(function (p) { return !Number.isInteger(p) || p < 1 || p > MAX_INDEX_PAGES || (data.lastPage && p > data.lastPage); })) return;
      lastIndexPage = data.lastPage;
      (data.entries || []).forEach(function (entry) { bestsellerRanks.set(String(entry[0]), Number(entry[1])); });
      (data.categories || []).forEach(function (entry) {
        categoryStats.set(String(entry[0]), { score:Number(entry[1]), bestRank:Number(entry[2]), hits:Number(entry[3]) });
      });
      (data.pages || []).forEach(function (page) { loadedIndexPages.add(Number(page)); });
    } catch (error) { /* ignore stale cache */ }
  }

  function validIndexEntries(entries, cached) {
    return Array.isArray(entries) && entries.every(function (entry) {
      if (!entry || (cached && (!Array.isArray(entry) || entry.length !== 2))) return false;
      var id = cached ? entry[0] : entry.id;
      var rank = cached ? entry[1] : entry.rank;
      return /^(?:gid:\/\/shopify\/Product\/)?[0-9]{8,}$/.test(String(id || '')) && Number.isInteger(Number(rank)) && Number(rank) > 0;
    });
  }

  function addIndexEntries(entries) {
    var neueRaenge = 0;
    (entries || []).forEach(function (entry) {
      var id = parseProductId(entry.id);
      var rank = Number(entry.rank || 999999);
      if (!id || !Number.isFinite(rank)) return;
      if (!bestsellerRanks.has(id) || rank < bestsellerRanks.get(id)) {
        bestsellerRanks.set(id, rank);
        neueRaenge += 1;
      }
      /* categoryStats wird weiter befuellt, wenn eine Antwort `collections`
         mitliefert — seit 13.08.2026 tut die Index-Section das nicht mehr, weil
         diese Map im gesamten Theme keinen Leser hat (die Kategorievorschlaege
         kommen aus categorySalesUnits und der Trefferhaeufigkeit in part-2).
         Der Zweig bleibt stehen, damit ein bewusstes Zurueckholen des Payloads
         ohne Codeaenderung wirkt; er laeuft derzeit schlicht nie. */
      var weight = 100000 / (rank + 25);
      (entry.collections || []).forEach(function (handle) {
        if (!handle) return;
        var current = categoryStats.get(handle) || { score:0, bestRank:999999, hits:0 };
        current.score += weight;
        current.bestRank = Math.min(current.bestRank, rank);
        current.hits += 1;
        categoryStats.set(handle, current);
      });
    });
    if (neueRaenge) meldeIndexUpdate();
  }

  /* ---- Gemeinsamer Bestseller-Index fuer BEIDE Oberflaechen (2026-08-11) ----
     Bis hierher konnte nur der Predictive-Code in dieser Datei auf
     bestsellerRanks zugreifen. Die vollstaendige Suchseite
     (sections/lmm-search-results) uebergab derselben Rankingengine deshalb
     hart bestRang:null — die Bestsellerstufe war dort dauerhaft wirkungslos,
     obwohl der Index laengst im Speicher lag. Gemessen an "LED Roehre die 58W
     ersetzt": 24 Treffer, 23 davon unbewertet, echte Raenge 1.308 bis 5.309,
     auf der Suchseite trotzdem in reiner Shopify-Reihenfolge.

     Statt eines zweiten Index bekommt die Suchseite eine schmale, NUR LESENDE
     Sicht auf genau diese eine Tabelle. Schluessel ist ausschliesslich die
     Shopify-Product-ID; Handle, URL-Pfad und Variant-ID sind ausdruecklich
     kein Ersatz. Die Map selbst wird nie herausgegeben — eine Mutation von
     aussen ist damit nicht moeglich. Unbekannter Rang gibt null zurueck,
     genau den neutralen Wert, den die Rangfolge bisher schon erhielt. */
  function meldeIndexUpdate() {
    indexEventOffen = true;
    if (indexEventTimer) return;
    /* Die Leerlaufstufe laedt Seite fuer Seite nach. Ohne diese Sammelstufe
       loeste jede einzelne Seite eine eigene Neusortierung aus. 250 ms fassen
       eine Nachladewelle zu EINEM Signal zusammen — gebuendelt wird an der
       Quelle, damit jede Oberflaeche denselben ruhigen Takt bekommt. */
    indexEventTimer = window.setTimeout(function () {
      indexEventTimer = 0;
      if (!indexEventOffen) return;
      indexEventOffen = false;
      var vollstaendig = indexIsComplete();
      /* Nur ein Signal, keine Produktdaten: Empfaenger lesen die Raenge selbst
         aus der Read-only-Sicht. */
      try {
        document.dispatchEvent(new CustomEvent('lmm:bestseller-index-updated', {
          detail: { bekannt: bestsellerRanks.size, seiten: loadedIndexPages.size, vollstaendig: vollstaendig }
        }));
        if (vollstaendig && !indexKomplettGemeldet) {
          indexKomplettGemeldet = true;
          document.dispatchEvent(new CustomEvent('lmm:bestseller-index-complete', {
            detail: { bekannt: bestsellerRanks.size, seiten: loadedIndexPages.size }
          }));
        }
      } catch (error) { /* Signal ist optional */ }
    }, 250);
  }

  window.LMMBestSellerIndex = Object.freeze({
    version: '2026.10.27-dynamic-pages-1',
    getRank: function (produktId) {
      var id = parseProductId(produktId);
      return id && bestsellerRanks.has(id) ? bestsellerRanks.get(id) : null;
    },
    hasRank: function (produktId) {
      var id = parseProductId(produktId);
      return !!(id && bestsellerRanks.has(id));
    },
    getKnownCount: function () { return bestsellerRanks.size; },
    getLoadedPages: function () { return loadedIndexPages.size; },
    isComplete: indexIsComplete,
    getLastPage: function () { return lastIndexPage || null; },
    /* Kein zweiter Index und keine zweite Anfrageserie: exakt dieselben
       Ladefunktionen, dieselbe Seitenbuchhaltung, derselbe sessionStorage-
       Cache. Notwendig, weil integrate() nur laeuft, wenn das Dropdown
       Ergebnisse zeigt — auf einer direkt aufgerufenen Suchseite blieb der
       gemeinsame Index dadurch bisher leer (am 11.08.2026 gemessen). Bereits
       geladene Seiten holt loadIndexPage nicht erneut. */
    ensureLoaded: function () {
      try { ensureIndexPages(EAGER_INDEX_PAGES).then(startIdleIndexLoad); }
      catch (error) { /* Index bleibt optional */ }
    }
  });

  async function loadIndexPage(page) {
    if (page < 1 || page > MAX_INDEX_PAGES || (lastIndexPage && page > lastIndexPage) || loadedIndexPages.has(page)) return;
    if (indexPagePromises.has(page)) return indexPagePromises.get(page);

    var promise = (async function () {
      var url = previewUrl('/collections/all');
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('page', String(page));


      url.searchParams.set('section_id', 'lmm-bestseller-index');
      var response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var payload = doc.querySelector('[data-lmm-bestseller-index]');
      var json = payload && payload.querySelector('script[type="application/json"]');
      if (!payload || !json) throw new Error('Bestseller index payload missing');
      var hasNext = payload.dataset.hasNext;
      if (Number(payload.dataset.page) !== page || (hasNext !== 'true' && hasNext !== 'false')) throw new Error('Bestseller pagination metadata invalid');
      var entries = JSON.parse(json.textContent || '[]');
      if (!validIndexEntries(entries, false)) throw new Error('Bestseller entries invalid');
      if (hasNext === 'false') {
        if (lastIndexPage && lastIndexPage !== page) throw new Error('Bestseller end page changed');
        lastIndexPage = page;
      }
      addIndexEntries(entries);
      loadedIndexPages.add(page);
      saveIndexCache();
      meldeIndexUpdate();
      sortVisibleProductsOnly();
    })().catch(function (error) {
      if (window.console) console.warn('[LMM Predictive] Bestseller-Index Seite ' + page + ' konnte nicht geladen werden.', error);
    }).finally(function () {
      indexPagePromises.delete(page);
    });

    indexPagePromises.set(page, promise);
    return promise;
  }

  async function ensureIndexPages(count) {
    var promises = [];
    for (var page = 1; page <= Math.min(count, MAX_INDEX_PAGES); page += 1) promises.push(loadIndexPage(page));
    await Promise.all(promises);
  }

  function startIdleIndexLoad() {
    if (idleIndexStarted) return;
    idleIndexStarted = true;
    var next = 1;
    function step() {
      while (next <= MAX_INDEX_PAGES && loadedIndexPages.has(next)) next += 1;
      if (next > MAX_INDEX_PAGES || (lastIndexPage && next > lastIndexPage)) return;
      loadIndexPage(next).finally(function () {
        next += 1;
        if ('requestIdleCallback' in window) requestIdleCallback(step, { timeout: 1200 });
        else setTimeout(step, 200);
      });
    }
    if ('requestIdleCallback' in window) requestIdleCallback(step, { timeout: 1200 });
    else setTimeout(step, 200);
  }

  function applyOrderIfChanged(list, currentNodes, sortedNodes, preserveScroll) {
    if (!(list instanceof HTMLElement) || currentNodes.length !== sortedNodes.length) return;
    var changed = sortedNodes.some(function (node, index) { return currentNodes[index] !== node; });
    if (!changed) return;

    var scroll = preserveScroll ? list.closest('[data-lmm-products-scroll]') : null;
    var previousTop = scroll ? scroll.scrollTop : 0;
    sortedNodes.forEach(function (node) { list.appendChild(node); });
    if (scroll) scroll.scrollTop = previousTop;
  }

  /* Nur den Produkt-TITEL lesen — node.textContent enthält seit den Alternativen-Chips
     auch fremde Artikelnamen (z. B. LED-Ersatz unter einer KLL) und würde falsch matchen. */
  function productTitleText(node) {
    var titleEl = node.querySelector('.lmm-predictive__ptitle');
    return String((titleEl || node).textContent || '').toLowerCase();
  }

  function productGroup(node, grouping) {
    if (!grouping || grouping.family !== '2g11') return 0;
    var text = productTitleText(node);
    var led = /\bled\b|corepro|led\s*(?:ersatz|alternative)/.test(text);
    var uva = /uv\s*[- ]?a|\buva\b|actinic|schwarzlicht/.test(text);
    var uvb = /uv\s*[- ]?b|\buvb\b|lichttherapie|\/01(?:\/|\b)/.test(text);
    var uvc = /uv\s*[- ]?c|\buvc\b|entkeim|\btuv\b/.test(text);
    var special = uva || uvb || uvc || /therapie|medizin|spezial/.test(text);
    var group = grouping.application === 'led' ? (led ? 0 : special ? 2 : 1)
      : grouping.application === 'uva' ? (uva ? 0 : special ? 1 : led ? 3 : 2)
      : grouping.application === 'uvb' ? (uvb ? 0 : special ? 1 : led ? 3 : 2)
      : grouping.application === 'uvc' ? (uvc ? 0 : special ? 1 : led ? 3 : 2)
      : (led ? 2 : special ? 1 : 0);
    if (grouping.brand && text.indexOf(grouping.brand === 'osram-ledvance' ? 'osram' : grouping.brand) === -1) group += 4;
    return group;
  }

  function productMatchesGrouping(node, grouping) {
    if (!grouping || grouping.family !== '2g11') return true;
    var text = productTitleText(node);
    if (!/(?:pl\s*[- ]?l|dulux\s+l|2g11|ralux\s+(?:rx-)?l)/.test(text)) return false;
    if (!grouping.watt) return true;
    var watt = String(Number(grouping.watt));
    return new RegExp('(?:^|[^0-9])' + watt.replace('.', '\\.') + '(?:[.,]0)?\\s*w', 'i').test(text);
  }

  /* Herstellergebundene Seriennamen (kompletter Katalog): Wer "pl-l" oder "tl-d" sucht,
     meint die Philips-Nomenklatur, wer "dulux" oder "hql" sucht, die Osram/Ledvance-Welt —
     die passende Marke rangiert vor dem Bestseller-Rang (innerhalb der Marke bleibt
     Bestseller-Reihenfolge). Nur eindeutige Serien, keine generischen Wörter. */
  function brandPriorityFromQuery(query) {
    var q = String(query || '').toLowerCase();
    /* Expliziter Markenname in der Suche gewinnt vor der Serien-Implikation. */
    if (/\bosram\b|\bledvance\b/.test(q)) return ['osram', 'ledvance'];
    if (/\bphilips\b|\bsignify\b/.test(q)) return ['philips', 'signify'];
    if (/\bsylvania\b/.test(q)) return ['sylvania'];
    if (/\bradium\b/.test(q)) return ['radium'];
    if (/\bmegaman\b/.test(q)) return ['megaman'];
    if (/\bpatron\b/.test(q)) return ['patron'];
    if (/\bmodee\b/.test(q)) return ['modee'];
    if (/\bevn\b/.test(q)) return ['evn'];
    if (/\bvarta\b/.test(q)) return ['varta'];
    if (/\bduracell\b/.test(q)) return ['duracell'];
    if (/\bwago\b/.test(q)) return ['wago'];
    if (/\bpl\s*[-/ ]?\s*[lcst]\b|\bpl[lcst]\b|\bmaster\b|\bcorepro\b|\btl\s*-?\s*[d5]\b|\btornado\b|\bplusline\b|\bcdm\b|\bson[- ]?[te]?\b|\btuv\b|\bactinic\b|\bhpl\b/.test(q)) return ['philips', 'signify'];
    if (/\bdulux\b|\blumilux\b|\bparathom\b|\bsubstitube\b|\bhaloline\b|\bdecostar\b|\bhalostar\b|\bhalopin\b|\bpowerball\b|\bxenophot\b|\bhql\b|\bhqi\b|\bnav\b|\blinestra\b/.test(q)) return ['osram', 'ledvance'];
    if (/\blynx\b|\bgrolux\b/.test(q)) return ['sylvania'];
    if (/\bralux\b|\bbonalux\b/.test(q)) return ['radium'];
    return null;
  }

  function nodeBrandRank(node, brands) {
    if (!brands) return 0;
    var el = node.querySelector('.lmm-predictive__brand');
    var text = String((el || node).textContent || '').toLowerCase();
    return brands.some(function (brand) { return text.indexOf(brand) !== -1; }) ? 0 : 1;
  }

  /* Hersteller-/Bestellnummern in der Query (>=4 zusammenhaengende Ziffern, z. B.
     "66748"): Treffer, die JEDE dieser Zahlen exakt im Karten-Text tragen (Titel
     oder Art.-Nr.), muessen VOR der Verkaufs-Sortierung stehen — sonst schiebt
     der Bestseller 66733 die echten 66748er nach unten (Chris 2026-07-12). */
  function queryNumberTokens(value) {
    var tokens = String(value || '').match(/\d{4,}/g);
    return tokens && tokens.length ? tokens : null;
  }

  function nodeNumberRank(node, tokens) {
    if (!tokens) return 0;
    var text = String(node.textContent || '');
    for (var i = 0; i < tokens.length; i++) {
      var re = new RegExp('(^|\\D)' + tokens[i] + '(\\D|$)');
      if (!re.test(text)) return 1;
    }
    return 0;
  }

  /* ---- Relevanz-Rangfolge (Chris 2026-08-04) -----------------------------
     Bis hierher sortierte im Dropdown der BESTSELLER-Rang, sobald die Query
     nicht als technisch erkannt wurde — und das war bei "Marke + Serie + ein
     Wert" der Regelfall. Ein fachlich unpassendes, aber gut verkauftes Produkt
     stand dadurch vor dem exakt passenden.

     Jetzt gilt durchgaengig RELEVANZ VOR BEWERTUNG VOR BESTSELLER. Die
     Rangklassen liegen in snippets/lmm-relevance-rank (window.LMMRelevance) —
     dieselbe Datei, die auch die vollstaendige Suchseite benutzt. Fehlt sie,
     bleibt die Liste in Serverreihenfolge; es gibt keinen zweiten,
     abweichenden Sortierpfad. */
  function attrVon(el, name) {
    return el ? String(el.getAttribute(name) || '') : '';
  }

  /* Liest den EINHEITLICHEN Attributsatz der Produktkarte (snippets/
     lmm-predictive-product). Die Herkunft der Karte — native Suggest-Section,
     native Nachladung oder Collection-Nachladung — spielt bewusst keine Rolle. */
  function relevanzDaten(node) {
    var el = node.querySelector('[data-lmm-tw]');
    var titelEl = node.querySelector('.lmm-predictive__ptitle');
    var markeEl = node.querySelector('.lmm-predictive__brand');
    var id = productId(node);
    var sku = attrVon(el, 'data-lmm-tsku');
    var ean = attrVon(el, 'data-lmm-tean');
    var gtin = attrVon(el, 'data-lmm-tgtin');
    return {
      titel: String((titelEl || node).textContent || ''),
      vendor: attrVon(el, 'data-lmm-tv') || String((markeEl && markeEl.textContent) || ''),
      sku: sku,
      ean: ean || gtin,
      mpn: attrVon(el, 'data-lmm-tmpn'),
      watt: attrVon(el, 'data-lmm-tw'),
      ersatzWatt: attrVon(el, 'data-lmm-trw'),
      sockel: attrVon(el, 'data-lmm-tb'),
      farbcode: attrVon(el, 'data-lmm-tc'),
      kelvin: attrVon(el, 'data-lmm-tkv'),
      lumen: attrVon(el, 'data-lmm-tlm'),
      lichtfarbe: attrVon(el, 'data-lmm-tlf'),
      laenge: attrVon(el, 'data-lmm-tln'),
      /* Abstrahlwinkel + CRI (2026-08-13): dieselben Collection-Filterfelder
         specs.beam_angle / specs.cri, siehe snippets/lmm-predictive-product. */
      beam: attrVon(el, 'data-lmm-tbe'),
      cri: attrVon(el, 'data-lmm-tcri'),
      typ: attrVon(el, 'data-lmm-tt'),
      /* Grober Suchklassifizierer-Bucket aus custom.product_kind (2026-08-13).
         Bisher lieferte nur die Suchseitenkarte diesen Wert (data-ptype); im
         Dropdown fehlte er, wodurch die Produktgruppen-Rueckfallebene dort blind
         war. Feldname `bucket` wie auf der Suchseite — lmm-relevance-rank liest
         genau diesen Namen. */
      bucket: attrVon(el, 'data-lmm-tpb'),
      kaufbar: el ? attrVon(el, 'data-lmm-tk') !== '0' : true,
      bewertung: attrVon(el, 'data-lmm-tra'),
      bewertungen: attrVon(el, 'data-lmm-trn'),
      bestRang: id && bestsellerRanks.has(id) ? bestsellerRanks.get(id) : null,
      /* Strukturierte Daten fuer Rangklasse 5 — ausdruecklich OHNE den Titel,
         damit ein Strukturtreffer keinen Titeltreffer vortaeuschen kann. */
      zusatzText: [sku, ean, gtin, attrVon(el, 'data-lmm-tmpn'), attrVon(el, 'data-lmm-tv'),
        attrVon(el, 'data-lmm-tt'), attrVon(el, 'data-lmm-tlf'), attrVon(el, 'data-lmm-tsh'),
        attrVon(el, 'data-lmm-tfo'), attrVon(el, 'data-lmm-tbg'),
        String(node.getAttribute('data-lmm-collections') || '').replace(/[,\-]/g, ' ')].join(' ')
    };
  }

  function techZeigeWieder(node) {
    if (node.dataset.lmmTechHidden) {
      node.style.removeProperty('display');
      delete node.dataset.lmmTechHidden;
    }
  }

  function verstecke(node) {
    node.style.display = 'none';
    node.dataset.lmmTechHidden = '1';
  }

  /* Identifier-Gate (Chris Phase 9). Eine reine Artikelnummern-/EAN-Anfrage
     liefert entweder den EXAKTEN Feldtreffer oder gar nichts. Shopify weicht
     Ziffernfolgen auf ("1030006306" fand den Osram BL Endura, weil dessen
     ARTIKELNAME eine fremde Nummer traegt) — solche Zeilen sind kein Treffer
     und werden nicht als Produktkarte angezeigt. Keine Naeherung ueber
     aehnliche Nummern, keine automatische Auswahl. */
  function identifierGate(scroll, list, nodes, analyse) {
    var treffer = nodes.filter(function (n) { return Number(n.dataset.lmmRKlasse) === 0; });
    nodes.forEach(function (n) {
      if (treffer.length && treffer.indexOf(n) !== -1) techZeigeWieder(n);
      else verstecke(n);
    });
    if (!scroll) return;
    if (scroll.dataset.lmmExactState === 'loading' || scroll.dataset.lmmExactState === 'unavailable') return;
    var note = scroll.querySelector('[data-lmm-ident-none]');
    if (treffer.length) {
      if (note) note.setAttribute('hidden', '');
      return;
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'lmm-predictive__none lmm-predictive__none--ident';
      note.setAttribute('data-lmm-ident-none', '');
      note.setAttribute('role', 'status');
      scroll.insertBefore(note, scroll.firstChild);
    }
    note.removeAttribute('hidden');
    /* Ohne verifizierte Zuordnung ist die ehrliche Aussage "nicht gefunden".
       "Nicht mehr verfuegbar" wuerde eine Kenntnis behaupten, die das Theme
       ohne gepflegte Alias-/Nachfolgerbeziehung nicht besitzt. */
    note.textContent = 'Die Artikelnummer „' + analyse.identifier
      + '“ wurde nicht gefunden. Bitte prüfen Sie die Eingabe oder kontaktieren Sie unsere Beratung.';
    var leer = scroll.querySelector('.lmm-predictive__none--products');
    if (leer) leer.setAttribute('hidden', '');
  }

  function sortProductList(list) {
    if (!(list instanceof HTMLElement)) return;
    var scroll = list.closest('[data-lmm-products-scroll]');
    var box = list.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
    var input = box && inputFor(box);
    var query = input ? String(input.value || '').trim() : (scroll ? String(scroll.dataset.query || '') : '');
    if (!query || !window.LMMRelevance) return;
    /* Hat der Kunde bereits gescrollt, bleibt die sichtbare Reihenfolge stehen —
       sonst springt ihm die Liste unter dem Finger weg. */
    if (scroll && scroll.scrollTop > 4) return;

    var analyse;
    try { analyse = window.LMMRelevance.analyze(query); } catch (fehler) { return; }
    var result = intentResult(query);
    var grouping = result && result.productGrouping;

    var nodes = Array.from(list.children).filter(function (node) { return node instanceof HTMLElement; });
    if (!nodes.length) return;

    nodes.forEach(function (node, index) {
      if (node.dataset.lmmOriginalOrder === undefined) node.dataset.lmmOriginalOrder = String(index);
      var v = null;
      try { v = window.LMMRelevance.rank(analyse, relevanzDaten(node)); } catch (fehler) { v = null; }
      if (!v) return;
      node.lmmRangVektor = v;
      /* Vollstaendig im DOM nachvollziehbar — jede Position ist erklaerbar. */
      node.dataset.lmmRKlasse = String(v.klasse);
      node.dataset.lmmRWarum = v.grund;
      node.dataset.lmmRHart = String(v.hart);
      node.dataset.lmmRSockel = String(v.sockel);
      node.dataset.lmmRTechnik = String(v.technik);
      node.dataset.lmmRMarke = String(v.marke);
      node.dataset.lmmRSerie = String(v.serie);
      node.dataset.lmmRFehl = String(v.fehl);
      node.dataset.lmmRPhrase = String(v.phrase);
      node.dataset.lmmRKaufbar = String(v.kaufbar);
      node.dataset.lmmRBewertung = String(v.bewertung);
      node.dataset.lmmRBewertungen = String(v.bewertungen);
      node.dataset.lmmBestRank = String(v.best);
      node.dataset.lmmProductGroup = String(productGroup(node, grouping));
    });

    var sorted = nodes.slice().sort(function (a, b) {
      /* Die 2G11-Anwendungsgruppen (UV-A/UV-B/UV-C/LED) bleiben unveraendert
         vorgeschaltet — sie trennen fachlich unvereinbare Anwendungen und
         greifen ausschliesslich bei einer erkannten 2G11-Familie. */
      if (grouping) {
        var ag = Number(a.dataset.lmmProductGroup || 0);
        var bg = Number(b.dataset.lmmProductGroup || 0);
        if (ag !== bg) return ag - bg;
      }
      var d = 0;
      if (a.lmmRangVektor && b.lmmRangVektor) d = window.LMMRelevance.vergleiche(a.lmmRangVektor, b.lmmRangVektor);
      if (d) return d;
      return Number(a.dataset.lmmOriginalOrder || 0) - Number(b.dataset.lmmOriginalOrder || 0);
    });

    if (analyse.identifier) {
      identifierGate(scroll, list, nodes, analyse);
    } else {
      /* HARTE WIDERSPRUECHE (Korrekturrunde 4, Chris Phase 3/10): Karten mit
         strukturiert widersprechendem Sockel, Produktgruppe, Ersatz-/
         Eigenleistung, Kelvin, Farbcode oder Laenge sind KEINE regulaeren
         Treffer und verschwinden IMMER — bewusst ohne Sicherung: lieber
         keine Produktkarte als eine fachlich falsche (Chris, Grundregel). */
      var hart = nodes.filter(function (n) {
        return n.lmmRangVektor && n.lmmRangVektor.hart > 0;
      });
      var weich = nodes.filter(function (n) { return hart.indexOf(n) === -1; });
      /* Strenge Kandidatenstufe: Solange mindestens ein fachlich exakter
         Treffer da ist (Klasse 0/1/2), verschwinden Zeilen ohne jeden Titel-
         oder Technikbezug — also 15-W-, 58-W- oder 140-W-Artikel bei einer
         16-W-Anfrage. Teiltreffer (Klasse 3/4) bleiben sichtbar, nur eben
         hinten. Sicherung (nur fuer die WEICHE Stufe): wuerde nichts uebrig
         bleiben, wird nichts versteckt. */
      var exakt = weich.filter(function (n) { return Number(n.dataset.lmmRKlasse) <= 2; });
      var raus = exakt.length
        ? weich.filter(function (n) { return Number(n.dataset.lmmRKlasse) >= 5; })
        : [];
      if (!raus.length || raus.length >= weich.length) { raus = []; }
      nodes.forEach(function (n) {
        if (hart.indexOf(n) !== -1 || raus.indexOf(n) !== -1) verstecke(n);
        else techZeigeWieder(n);
      });
      var offen = scroll && scroll.querySelector('[data-lmm-ident-none]');
      if (offen) offen.setAttribute('hidden', '');
      /* Ehrliche Leermeldung (Korrekturrunde 4, Phase 7/11): bleiben nach dem
         harten Ausschluss null Karten sichtbar, sagt das Dropdown das auch —
         keine Karte darf ausgeschlossene Produkte als Treffer behaupten. */
      if (scroll) {
        var sichtbarZahl = 0;
        nodes.forEach(function (n) { if (!n.dataset.lmmTechHidden) sichtbarZahl += 1; });
        var leerNote = scroll.querySelector('.lmm-predictive__none--products');
        if (sichtbarZahl === 0 && hart.length) {
          if (!leerNote) {
            leerNote = document.createElement('p');
            leerNote.className = 'lmm-predictive__none--products';
            scroll.insertBefore(leerNote, scroll.firstChild);
          }
          leerNote.textContent = 'Keine passenden Artikel gefunden.';
          leerNote.removeAttribute('hidden');
        } else if (leerNote && sichtbarZahl > 0) {
          leerNote.setAttribute('hidden', '');
        }
      }
    }
    applyOrderIfChanged(list, nodes, sorted, true);
  }

  function collectionHandleFromUrl(value) {
    if (!value) return '';
    try {
      var match = new URL(String(value), location.origin).pathname.match(/^\/collections\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) { return ''; }
  }

  function categoryHandle(node) {
    var link = node && node.querySelector ? node.querySelector('a[href*="/collections/"]') : null;
    return link ? collectionHandleFromUrl(link.getAttribute('href')) : '';
  }

  function primaryCategoryHandle(list) {
    var box = list && list.closest ? list.closest('[ref="predictiveSearchResults"], .lmm-predictive__results') : null;
    var input = box && inputFor(box);
    var query = input ? input.value.trim() : '';
    var result = query ? intentResult(query) : null;
    return result && result.mode === 'route' ? (result.categoryPrimaryHandle || collectionHandleFromUrl(result.targetUrl)) : '';
  }

  function sortCategoryList(list) {
    if (!(list instanceof HTMLElement)) return;
    initExactCategoryData();

    /* „Kategorien dieses Artikels" (Artikelnummer-Suche): die Server-Reihenfolge ist
       bewusst Baumtiefe (spezifischste Kategorie zuerst, aufsteigende Artikelzahl) —
       NICHT nach Verkäufen umsortieren (sonst stehen Wurzel-/Marken-Collections wieder
       oben). Nur die Katalogbilder nachrüsten. */
    if (list.hasAttribute('data-lmm-product-cats')) {
      Array.from(list.children).forEach(function (node) {
        if (node instanceof HTMLElement) ensureCategoryImage(node, categoryHandle(node));
      });
      return;
    }

    var primaryHandle = primaryCategoryHandle(list);
    var box = list.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
    var input = box && inputFor(box);
    var result = input ? intentResult(input.value.trim()) : null;
    var categoryPriority = result && Array.isArray(result.categoryPriority) ? result.categoryPriority : [];
    var nodes = Array.from(list.children).filter(function (node) { return node instanceof HTMLElement; });
    if (nodes.length < 1) return;

    nodes.forEach(function (node, index) {
      if (node.dataset.lmmOriginalOrder === undefined) node.dataset.lmmOriginalOrder = String(index);
      var handle = categoryHandle(node);
      var hasExactUnits = handle && categorySalesUnits.has(handle);
      var units = hasExactUnits ? categorySalesUnits.get(handle) : -1;
      node.dataset.lmmCategoryHandle = handle;
      node.dataset.lmmCategoryPrimary = handle && handle === primaryHandle ? '1' : '0';
      node.dataset.lmmCategoryPriority = String(handle && categoryPriority.indexOf(handle) !== -1 ? categoryPriority.indexOf(handle) : 999);
      node.dataset.lmmCategoryHasExactUnits = hasExactUnits ? '1' : '0';
      node.dataset.lmmCategoryUnits = String(units);
      ensureCategoryImage(node, handle);
    });

    var sorted = nodes.slice().sort(function (a, b) {
      var ap = Number(a.dataset.lmmCategoryPrimary || 0);
      var bp = Number(b.dataset.lmmCategoryPrimary || 0);
      if (ap !== bp) return bp - ap;

      var apr = Number(a.dataset.lmmCategoryPriority || 999);
      var bpr = Number(b.dataset.lmmCategoryPriority || 999);
      if (apr !== bpr) return apr - bpr;

      var ae = Number(a.dataset.lmmCategoryHasExactUnits || 0);
      var be = Number(b.dataset.lmmCategoryHasExactUnits || 0);
      if (ae !== be) return be - ae;

      var au = Number(a.dataset.lmmCategoryUnits || -1);
      var bu = Number(b.dataset.lmmCategoryUnits || -1);
      if (au !== bu) return bu - au;

      return Number(a.dataset.lmmOriginalOrder || 0) - Number(b.dataset.lmmOriginalOrder || 0);
    });
    applyOrderIfChanged(list, nodes, sorted, false);
  }

  function sortVisibleProductsOnly(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.lmm-predictive__prods').forEach(sortProductList);
  }

  function sortAllVisible(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.lmm-predictive__prods').forEach(sortProductList);
    scope.querySelectorAll('.lmm-predictive__cats, .lmm-intent-categories').forEach(sortCategoryList);
  }

  /* „Passende Kategorien" bei Spec-Suchen (z. B. "14W/840") aus den BESTSELLER-sortierten
     Top-Treffern neu ableiten: die Server-Section kennt nur die Relevanz-Reihenfolge der
     Suggest-API (dort stehen oft Leuchten vorn). Quelle: data-lmm-collections der ersten
     6 sichtbaren Zeilen; Rang = geteilt von möglichst vielen Treffern, dann kleinste
     Collection (Baumtiefe). Nur Katalog-Collections (kuratierte Navigationsziele). */
  function refreshProductCats(box) {
    if (!(box instanceof HTMLElement)) return;
    var native = box.querySelector('[data-lmm-native-categories]');
    var list = native && native.querySelector('[data-lmm-product-cats]');
    if (!list) return;
    var rows = Array.from(box.querySelectorAll('.lmm-predictive__prods .lmm-predictive__prod')).slice(0, 6);
    if (!rows.length) return;
    initExactCategoryData();
    if (!catalogByHandle.size) return;
    var freq = new Map();
    rows.forEach(function (row, index) {
      String(row.getAttribute('data-lmm-collections') || '').split(',').forEach(function (handle) {
        handle = handle.trim();
        if (!handle || !catalogByHandle.has(handle)) return;
        var entry = freq.get(handle) || { hits: 0, best: index };
        entry.hits += 1;
        entry.best = Math.min(entry.best, index);
        freq.set(handle, entry);
      });
    });
    if (!freq.size) return;
    /* Rang: erst Kategorien, die MEHRERE Top-Treffer teilen (Einzelausreißer nach hinten),
       darin die KLEINSTE zuerst (= unterste Baumebene, Regel Chris) — sonst gewinnen die
       von allen geteilten Riesen wie "Leuchtmittel"/"Osram" wieder die Spitze. */
    var ranked = Array.from(freq.keys()).sort(function (a, b) {
      var fa = freq.get(a), fb = freq.get(b);
      var sharedA = fa.hits >= 2 ? 0 : 1;
      var sharedB = fb.hits >= 2 ? 0 : 1;
      if (sharedA !== sharedB) return sharedA - sharedB;
      var ca = catalogByHandle.get(a), cb = catalogByHandle.get(b);
      if ((ca.count || 0) !== (cb.count || 0)) return (ca.count || 0) - (cb.count || 0);
      return fa.best - fb.best;
    }).slice(0, 5);
    var signature = ranked.join('|');
    if (list.dataset.lmmCatsSignature === signature) return;   /* kein unnötiges Neu-Rendern */
    list.dataset.lmmCatsSignature = signature;
    list.textContent = '';
    ranked.forEach(function (handle) {
      var item = catalogByHandle.get(handle);
      var li = document.createElement('li');
      li.className = 'predictive-search-results__card lmm-predictive__cat';
      li.setAttribute('ref', 'resultsItems[]');
      var link = document.createElement('a');
      link.className = 'lmm-predictive__cat-a';
      link.href = item.url;
      var ico = document.createElement('span');
      ico.className = 'lmm-predictive__cat-ico';
      ico.setAttribute('aria-hidden', 'true');
      if (item.image) {
        var img = document.createElement('img');
        img.src = item.image; img.alt = ''; img.width = 46; img.height = 46; img.loading = 'lazy';
        ico.appendChild(img);
      } else {
        ico.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="6" rx="1.4"/><rect x="3" y="14" width="18" height="6" rx="1.4"/></svg>';
      }
      var copy = document.createElement('span');
      copy.className = 'lmm-predictive__cat-copy';
      var title = document.createElement('span');
      title.className = 'lmm-predictive__cat-t';
      title.textContent = item.title;
      copy.appendChild(title);
      if (item.count > 0) {
        var count = document.createElement('span');
        count.className = 'lmm-predictive__cat-count';
        count.textContent = Number(item.count).toLocaleString('de-DE') + ' Artikel';
        copy.appendChild(count);
      }
      link.appendChild(ico);
      link.appendChild(copy);
      li.appendChild(link);
      list.appendChild(li);
    });
  }

  function intentResult(query) {
    if (!window.LMMSearchIntent || typeof window.LMMSearchIntent.resolve !== 'function') return null;
    try { return window.LMMSearchIntent.resolve(query); } catch (error) { return null; }
  }

  function targetCollectionUrl(result) {
    if (!result || result.mode !== 'route' || !result.targetUrl) return null;


    try {
      var url = previewUrl(result.targetUrl);
      if (!/^\/collections\/[^/]+/.test(url.pathname)) return null;
      url.searchParams.set('sort_by', 'best-selling');
      return url;
    } catch (error) { return null; }
  }

  /* Liefert die native Suche 0 Treffer, rendert die Section KEINE Produktliste —
     Collection-Nachladungen (z. B. "cr2032" → Knopfzellen) brauchen den Container
     dann trotzdem. Leermeldung wird erst versteckt, wenn wirklich Produkte da sind. */
  function ensureProductList(scroll) {
    var list = scroll.querySelector('.lmm-predictive__prods');
    if (list) return list;
    list = document.createElement('ul');
    list.className = 'predictive-search-results__list predictive-search-results__wrapper-products lmm-predictive__prods list-unstyled';
    scroll.insertBefore(list, scroll.firstChild);
    return list;
  }

  /* KERNAENDERUNG 2026-08-04 (Chris Phase 4): Die vom Server gerenderten
     NATIVEN Predictive-Treffer duerfen nie mehr geloescht werden. Bisher rief
     jede Nachladung list.replaceChildren() auf — damit verschwand die von
     Shopify korrekt gefundene Trefferliste vollstaendig und wurde durch
     Kategorie-Bestseller ersetzt. Ein nativer Rang-1-Treffer ging so allein
     durch eine fehlende manuelle Collection-Zuordnung verloren.
     Jetzt werden ausschliesslich die von UNS angehaengten Zeilen entfernt;
     alles, was die Section geliefert hat, bleibt stehen. */
  function resetNachladungen(list) {
    if (!list) return;
    list.querySelectorAll('[data-lmm-appended]').forEach(function (node) { node.remove(); });
  }

  function anhaengen(list, node) {
    var kopie = document.importNode(node, true);
    kopie.setAttribute('data-lmm-appended', '1');
    list.appendChild(kopie);
    return kopie;
  }

  /* Alle Filter der PRIMAERroute, damit die Fallback-Stufe keinen davon
     stillschweigend fallen laesst. Belegter Fehlerfall (2026-08-04):
     Primaerroute mit filter.p.vendor=Philips lief leer, der Fallback lud
     dieselbe Collection OHNE Filter — und ergaenzte Osram-Produkte, obwohl
     die Query ausdruecklich Philips verlangte. */
  function primaerFilter(scroll) {
    var url = String((scroll && scroll.dataset.collectionPrimaryUrl) || '');
    var frage = url.indexOf('?');
    if (frage === -1 || !window.URLSearchParams) return null;
    try { return new URLSearchParams(url.slice(frage + 1)); } catch (fehler) { return null; }
  }

  function vendorErlaubt(node, wuensche) {
    if (!wuensche || !wuensche.length) return true;
    var el = node.querySelector('[data-lmm-tw]');
    var marke = node.querySelector('.lmm-predictive__brand');
    var text = ((el && el.getAttribute('data-lmm-tv')) || (marke && marke.textContent) || '').toLowerCase();
    var titel = node.querySelector('.lmm-predictive__ptitle');
    var titelText = String((titel && titel.textContent) || '').toLowerCase();
    return wuensche.some(function (w) {
      var v = String(w || '').toLowerCase().trim();
      if (!v) return true;
      return text.indexOf(v) !== -1 || titelText.indexOf(v) !== -1;
    });
  }

  function hideEmptyNoteIfFilled(scroll, list) {
    if (!list || !list.children.length) return;
    /* KORREKTURRUNDE 4: hart ausgeschlossene (versteckte) Karten zaehlen NICHT
       als Fuellung — sonst verschwaende die ehrliche Leermeldung, obwohl der
       Kunde keine einzige Karte sieht (belegt 05.08.2026 bei "g9 fassung"). */
    var sichtbar = Array.prototype.filter.call(list.children, function (n) {
      return n instanceof HTMLElement && !n.dataset.lmmTechHidden && n.style.display !== 'none';
    });
    if (!sichtbar.length) return;
    var empty = scroll.querySelector('.lmm-predictive__none--products');
    if (empty) empty.setAttribute('hidden', '');
  }

  async function loadCollectionPage(scroll, page, replace) {
    if (!(scroll instanceof HTMLElement) || scroll.dataset.loading) return;
    var requestBox = scroll.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
    var requestInput = requestBox && inputFor(requestBox);
    var expectedQuery = requestInput ? requestInput.value.trim() : (scroll.dataset.query || '');
    var baseUrl = scroll.dataset.collectionUrl;
    if (!baseUrl) return;
    scroll.dataset.loading = '1';
    scroll.classList.add('is-loading');
    try {
      var url = previewUrl(baseUrl);
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', 'lmm-predictive-collection-products');
      var cacheKey = url.pathname + url.search;
      var html = collectionPageCache.get(cacheKey) || '';
      if (!html) {
        var response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        html = await response.text();
        collectionPageCache.set(cacheKey, html);
      }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var payload = doc.querySelector('[data-lmm-collection-products]');
      await new Promise(function (resolve) { setTimeout(resolve, 160); });
      var liveScroll = Array.from(document.querySelectorAll('[ref="predictiveSearchResults"], .lmm-predictive__results')).map(function (candidateBox) {
        var candidateInput = inputFor(candidateBox);
        return candidateInput && candidateInput.value.trim() === expectedQuery ? candidateBox.querySelector('[data-lmm-products-scroll]') : null;
      }).find(Boolean);
      if (liveScroll) scroll = liveScroll;
      if (!payload || !(scroll instanceof HTMLElement)) return;
      var list = ensureProductList(scroll);
      var incoming = payload.querySelector('.lmm-predictive__prods');
      if (!list || !incoming) return;
      if (replace) resetNachladungen(list);
      var keys = existingKeys(list);
      var box = scroll.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
      var input = box && inputFor(box);
      var result = input ? intentResult(input.value.trim()) : null;
      var grouping = result && result.productGrouping;
      var fallbackPhase = scroll.dataset.collectionPhase === 'fallback';
      var watt = grouping && grouping.watt ? String(Number(grouping.watt)) : '';
      if (!watt) {
        var queryWatt = String(expectedQuery || '').match(/(\d{1,3}(?:[.,]\d)?)\s*w(?:att)?\b/i);
        if (queryWatt) watt = String(Number(queryWatt[1].replace(',', '.')));
      }
      var wattPattern = watt ? new RegExp('(?:^|[^0-9])' + watt.replace('.', '\\.') + '(?:[.,]0)?\\s*w', 'i') : null;
      /* LMM (2026-07-28): Lichtfarben-Code aus der Query am Titel gegenprüfen —
         genau wie die Wattangabe eine Zeile darüber. Ohne diese Prüfung kamen bei
         „36w/840 T8 led" Röhren in 865 und 830 ins Dropdown: Der Resolver baut
         wattage=36 + kelvin=4000, wattage=36 trifft bei Retrofit-LEDs nichts
         (dort steht die ECHTE Leistung, nicht die ersetzte 36-W-Röhre), die
         gefilterte Route lief leer — und der Fallback lädt die Collection ohne
         jeden Filter, also Bestseller aller Lichtfarben.
         Abgelehnt wird nur, wenn der Titel eine ANDERE Lichtfarbe trägt. Titel
         ohne Code (z. B. nur „neutralweiß" ausgeschrieben) bleiben drin.
         Erste Ziffer = Farbwiedergabe-Band, die beiden letzten mal 100 = Kelvin.
         Deshalb eine explizite Liste der real vorkommenden Endungen statt \d\d —
         sonst fällt 865 durchs Raster (endet auf 5) und „800 Lumen" würde
         fälschlich als Lichtfarbe gelesen. */
      var FARB_CODE = '[89](?:2[257]|3[035]|40|5[07]|6[05])';
      var farbCode = String(expectedQuery || '').match(new RegExp('(?:^|[^0-9])(' + FARB_CODE + ')(?:$|[^0-9])'));
      var farbPattern = farbCode ? new RegExp('(?:^|[^0-9])' + farbCode[1] + '(?:$|[^0-9])') : null;
      var FARB_CODE_IM_TITEL = new RegExp('(?:^|[^0-9])' + FARB_CODE + '(?:$|[^0-9])');
      /* Vendor-Wunsch der Primaerroute — gilt in ALLEN Stufen, auch im
         ungefilterten Fallback (Chris Phase 5). */
      var filterPrimaer = primaerFilter(scroll);
      var vendorWunsch = filterPrimaer ? filterPrimaer.getAll('filter.p.vendor') : [];
      var added = 0;
      incoming.querySelectorAll('.lmm-predictive__prod').forEach(function (node) {
        if (grouping && !productMatchesGrouping(node, grouping)) return;
        /* Watt aus der Query IMMER am Titel prüfen (nicht nur im Fallback): manche
           Collections ignorieren unbekannte Filter-Parameter und liefern ungefiltert.
           NUR der Produkt-Titel zählt — die Alternativen-Chips enthalten fremde Watt. */
        var wattTitleEl = node.querySelector('.lmm-predictive__ptitle');
        if (wattPattern && !wattPattern.test((wattTitleEl || node).textContent || '')) return;
        if (farbPattern) {
          var farbTitel = (wattTitleEl || node).textContent || '';
          if (FARB_CODE_IM_TITEL.test(farbTitel) && !farbPattern.test(farbTitel)) return;
        }
        if (!vendorErlaubt(node, vendorWunsch)) return;
        var key = productKey(node);
        if (!key || keys.has(key)) return;
        keys.add(key);
        anhaengen(list, node);
        added += 1;
      });
      sortProductList(list);
      hideEmptyNoteIfFilled(scroll, list);
      var hasNext = payload.dataset.hasNext === 'true';
      if (added > 0) scroll.dataset.autoPages = '0';
      if (hasNext) {
        scroll.dataset.nextPage = String(page + 1);
        scroll.dataset.done = '0';
      } else if (scroll.dataset.collectionFallbackUrl && scroll.dataset.collectionPhase !== 'fallback') {
        scroll.dataset.collectionPhase = 'fallback';
        scroll.dataset.collectionUrl = scroll.dataset.collectionFallbackUrl;
        scroll.dataset.nextPage = '1';
        scroll.dataset.done = '0';
        scroll.dataset.autoPages = '0';
        var hasRequestedGroup = !grouping || !grouping.application || Array.from(list.children).some(function (node) { return productGroup(node, grouping) === 0; });
        if (!hasRequestedGroup || scroll.scrollTop + scroll.clientHeight >= scroll.scrollHeight - 120) scroll.dataset.loadAfterPage = '1';
      } else {
        scroll.dataset.done = '1';
      }
      /* Auto-Weiterblättern, wenn der Titel-/Gruppenfilter eine Seite leert —
         begrenzt auf 6 Seiten in Folge, damit große Collections nicht
         komplett durchgeladen werden. */
      var autoPages = Number(scroll.dataset.autoPages || 0);
      if (hasNext && autoPages < 6 && (added === 0 || scroll.scrollHeight <= scroll.clientHeight + 20)) {
        scroll.dataset.autoPages = String(autoPages + 1);
        scroll.dataset.loadAfterPage = String(page + 1);
      }
      scroll.dataset.source = 'collection';
      scroll.closest('.lmm-predictive__products-pane')?.setAttribute('data-lmm-source', 'collection');
    } catch (error) {
      scroll.dataset.error = '1';
      if (window.console) console.warn('[LMM Predictive] Bestseller-Collection konnte nicht geladen werden.', error);
    } finally {
      if (!(scroll instanceof HTMLElement)) return;
      delete scroll.dataset.loading;
      scroll.classList.remove('is-loading');
      var loadAfterPage = Number(scroll.dataset.loadAfterPage || 0);
      delete scroll.dataset.loadAfterPage;
      if (loadAfterPage) setTimeout(function () { loadCollectionPage(scroll, loadAfterPage, false); }, 0);
    }
  }

  /* Generische Wattsuche (Chris 2026-07-29).
     Shopify liefert je nach Schreibweise eine ANDERE Kandidatenmenge: Bei "18W"
     ist die meistverkaufte 18-W-Roehre (Osram Lumilux T8 L 18W/840, Bestseller-
     Rang 8) in 96 Treffern ueber 4 Seiten ueberhaupt nicht enthalten, bei "18W/"
     steht sie auf Serverposition 0. Die clientseitige Bestseller-Sortierung
     unten kann nur ordnen, was geliefert wird — deshalb wird die ANFRAGE
     vereinheitlicht, nicht die Sortierung geaendert.

     Es greift ausschliesslich der Fall, dass die GESAMTE Query aus einem
     Watt-Token besteht ("18W", "18 W", "18 Watt", "18W/", "18 W/"). Damit sind
     diese Schreibweisen buchstaeblich identisch — ein abschliessender Schraeg-
     strich kann die Reihenfolge nicht mehr veraendern. Jede andere Query
     ("18W/840", "L 18W/840", "t8 18w", "dulux te 18w", Artikelnummern, EANs)
     bleibt byteidentisch; eine Regression ist konstruktionsbedingt ausge-
     schlossen und wurde zusaetzlich gemessen.

     Die kanonische Form "<Zahl>W/" ist nicht geraten, sondern read-only gegen
     den Server bestimmt: von fuenf Kandidatenformen liefert sie als einzige bei
     allen sechs geprueften Wattstufen (11/13/18/26/36/58) eine passende
     Wattzahl auf Platz 1 und fuer alle Top-5-Treffer einen Bestseller-Rang.
     Nur ganze Zahlen — Dezimalwerte bleiben unveraendert, weil ungeprueft. */
  var NUR_WATT = /^\s*(\d{1,3})\s*(?:watt|w)\s*[/\-.,;:]*\s*$/i;

  function wattKanonisch(query) {
    var text = String(query == null ? '' : query);
    var kompakt = text.trim().replace(/^variants\.(?:sku|barcode):\s*/i, '').replace(/[\s\-.\u2010-\u2015]/g, '');
    if (/^[0-9]{10}$/.test(kompakt)) return 'variants.sku:' + kompakt;
    if (/^[0-9]{13}$/.test(kompakt)) return 'variants.barcode:' + kompakt;
    var treffer = NUR_WATT.exec(text);
    return treffer ? treffer[1] + 'W/' : text;
  }

  /* ---- KANDIDATENPOOL-STUFE DES DROPDOWNS (2026-08-11) -------------------
     Gegenstueck zur Seitenstufe der vollstaendigen Suchseite
     (sections/lmm-search-results, POOL_SEITEN_MAX). Belegt am 11.08.2026 im
     Canary 203799626065 fuer "18W Leuchtstoffroehre durch LED ersetzen":
     Die strenge Kandidatenstufe liefert 90 Produkte auf 4 Seiten — DIESELBEN
     90, die auch die Suchseite laedt. Das Dropdown lud davon nur Seite 1 und
     hielt an, weil seine bisherige Abbruchbedingung REIN GEOMETRISCH war:
     sobald der Scrollbereich gefuellt ist (hier 22 sichtbare Karten), wurde
     nicht weiter geblaettert. Das fachlich beste Produkt (5,0 aus 5
     Bewertungen, Bestseller-Rang 550) steht auf Seite 2 und war im Dropdown
     ueberhaupt nicht vorhanden — kein Rangfehler, ein Kandidatenpool-Fehler.
     Warum Seite 1 nicht genuegt, obwohl sort_by=best-selling gesetzt wird:
     der Parameter ist auf der /search-Route wirkungslos (gemessen — Seite 1
     beginnt mit Bestseller-Rang 1968 statt 550, Backlog LMM-119). Die
     Serverreihenfolge taugt deshalb nicht als Vorauswahl; entweder der
     verengte Satz ist da oder die Rangfolge ist zufaellig beschnitten.
     Ausgeloest wird die Stufe NUR im selben technischen Zustand, den die
     Suchseite mit lmm_tech=1 markiert — verifizierte Techfilter aus
     LMMTechRank.filterParams, keine Identifier-Anfrage, Gate nicht
     abgeschaltet. Das ist wortgleich dasselbe Praedikat, keine zweite Regel.
     Keine Katalogvollsuche: geladen werden ausschliesslich weitere Seiten
     DERSELBEN bereits verengten Anfrage, mit denselben Filterparametern.
     Grenze wie auf der Suchseite: hoechstens vier ZUSAETZLICHE Seiten.
     Bewusste Abweichung von deren "entweder vollstaendig oder gar nicht"-
     Regel: die Seitenzahl steht dem Dropdown vorab nicht zur Verfuegung (die
     Section lmm-predictive-more meldet nur has-next), und das Dropdown ist
     eine Vorschau mit dauerhaftem Link auf die vollstaendige Trefferliste —
     ein begrenzter Pool ist dort keine stille Kappung. Der erreichte Zustand
     ist am Scrollbereich als data-lmm-drop-pool ablesbar
     (laedt | vollstaendig | begrenzt). */
  var DROP_POOL_SEITEN_MAX = 4;

  /* ---- QUERY-GUARD FUER HAENGENDE NACHLADEKETTEN (2026-08-11) -------------
     Belegt am 11.08.2026 im Canary 203799626065: Wechselt der Kunde die
     Anfrage, waehrend eine Nachladekette noch laeuft, arbeitete die
     eingeplante Fortsetzung mit der NEUEN Query weiter — aber mit der ALTEN
     Seitennummer. loadNativePage liest die Query zu Beginn JEDES Aufrufs neu
     aus dem Eingabefeld; der Vergleich weiter unten schuetzt deshalb nur vor
     einer Antwort, die waehrend DIESES Aufrufs veraltet, nicht vor einer
     Fortsetzung, die fuer eine andere Query eingeplant wurde.
     Gemessene Folge: "LED 6W E27" (Kette bis Seite 6 offen) gefolgt von
     "18W Leuchtstoffroehre durch LED ersetzen" ergab 66 statt 90 Karten und
     49 statt 71 sichtbaren Produkten — die Seite-1-Ladung der neuen Anfrage
     wurde von einer Fortsetzung der alten ueberholt.
     Die Kette traegt jetzt die Query, fuer die sie eingeplant wurde, und
     endet, sobald das Eingabefeld etwas anderes enthaelt. Das erfuellt die
     Vorgabe "Query-Wechsel muss alte Requests abbrechen beziehungsweise
     deren Ergebnis verwerfen" fuer die gesamte Kette statt nur fuer den
     einzelnen Aufruf. */
  function ketteFort(scroll, eingabe, fuerQuery, naechsteSeite, fuerKette) {
    setTimeout(function () {
      if (!eingabe || String(eingabe.value || '').trim() !== fuerQuery) { return; }
      if (String(scroll.dataset.lmmKette || '0') !== String(fuerKette)) { return; }
      loadNativePage(scroll, naechsteSeite, false);
    }, 0);
  }

  async function loadNativePage(scroll, page, replace) {
    if (!(scroll instanceof HTMLElement) || scroll.dataset.loading === '1' || (!replace && scroll.dataset.done === '1')) return;
    var box = scroll.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
    var input = box && inputFor(box);
    var query = input ? input.value.trim() : '';
    if (!query) return;
    var list = ensureProductList(scroll);
    if (!list) return;
    page = Number(page || 1);
    /* ---- KETTENIDENTITAET (2026-08-11) ------------------------------------
       loadNativePage kann mehrfach nebeneinander neu gestartet werden — die
       Komponente ruft bei einer Eingabe mehr als einmal mit replace=true auf
       (gemessen am 11.08.2026: zwei vollstaendige Ketten 2,0 s auseinander).
       scroll.dataset.loading schuetzt nur den EINZELNEN Aufruf, nicht die
       Kette. Solange jede Kette nur eine Seite lud, war die Ueberlappung
       folgenlos; mit der mehrseitigen Kandidatenpool-Stufe ist sie es nicht:
       Ein replace der zweiten Kette leerte die Liste mitten in der ersten,
       Ergebnis 66 statt 90 Karten und 49 statt 71 sichtbaren Produkten —
       reproduzierbar beim Wechsel von "LED 6W E27" auf
       "18W Leuchtstoffroehre durch LED ersetzen".
       Jede replace-Ladung eroeffnet deshalb eine neue Kette. Eine ueberholte
       Kette schreibt weder in die Liste noch setzt sie sich fort; ihr bereits
       laufender Request laeuft ins Leere statt in eine halb geleerte Liste.
       Der Server ist an dieser Stelle nachweislich nicht schuld: zwei
       identische Abrufe von Seite 1 und Seite 2 lieferten byteidentische
       Trefferlisten mit 0 Ueberschneidung. */
    if (replace) {
      scroll.dataset.lmmKette = String((Number(scroll.dataset.lmmKette || 0) + 1) % 1000000);
    }
    var kette = String(scroll.dataset.lmmKette || '0');
    scroll.dataset.loading = '1';
    scroll.classList.add('is-loading');
    try {
      var base = (window.Theme && Theme.routes && Theme.routes.search_url) || '/search';
      var url = previewUrl(base);
      var result = intentResult(query);
      /* Eine vom Resolver kuratierte nativeQuery bleibt unangetastet.
         KORREKTURRUNDE 2: hat der Resolver keine, entscheidet die erkannte
         Produktfamilie. Damit laden "LED Leuchtroehre", "LED Leuchtstoffroehre",
         "LED Roehre" und "LED Tube" denselben fachlichen Bestand, statt vier
         verschiedene Spitzenprodukte zu zeigen. Sichtbar bleibt die
         urspruengliche Eingabe des Kunden. */
      var famNativ = null;
      if (window.LMMRelevance) {
        try {
          var famAnalyse = window.LMMRelevance.analyze(query);
          if (famAnalyse.familie && famAnalyse.familie.nativeQuery
              && (famAnalyse.restTokens || []).length === 0) {
            famNativ = famAnalyse.familie.nativeQuery;
          }
        } catch (fehler) { famNativ = null; }
      }
      /* KORREKTURRUNDE 3 (Chris Phase 5): kompakte technische Schreibweisen
         ("13w840", "hns-15w-g13", "g 9 2,6 w") liefern nativ null Treffer.
         Die ZERLEGTE Form laedt denselben fachlichen Bestand wie die uebliche
         Schreibweise — nur fuer die interne Nachladeanfrage, die sichtbare
         Kundeneingabe bleibt unveraendert (bewaehrtes Muster wattKanonisch). */
      var techKanon = null;
      if (window.LMMTechRank && window.LMMTechRank.kanonischeQuery) {
        try { techKanon = window.LMMTechRank.kanonischeQuery(query); }
        catch (fehler) { techKanon = null; }
      }
      url.searchParams.set('q', (result && result.nativeQuery)
        ? result.nativeQuery
        : (famNativ || techKanon || wattKanonisch(query)));
      url.searchParams.set('type', 'product');
      /* Strenge Kandidatenstufe (Chris 2026-07-30) — DIESELBEN nativen
         Attributfilter, die auch die vollstaendige Suchseite setzt. Damit
         benutzen Dropdown und Suchseite nicht nur dieselbe Rangfolge, sondern
         auch dieselbe Kandidatenmenge.
         Grund: Shopify weicht die Query auf. Read-only am 2026-07-30 gemessen —
         q="16W/840" liefert 17 Treffer, q="16W/840 G13" dagegen 605. Ein
         ZUSAETZLICHER Term VERGROESSERT die Menge; so kamen 58-W- und
         140-W-Artikel in die Liste. Mit specs.wattage=16.0 + specs.color_code=840
         bleiben 11. Welche Filter wirken, ist belegt (specs.base wirkt NICHT). */
      var techSpec = window.LMMTechRank ? window.LMMTechRank.parse(query) : null;
      var gateAus = scroll.dataset.techGateAus === query;
      /* Zweite Stufe (Chris 2026-07-30, zweite Runde): Ist die strenge Stufe
         durchgeblaettert, folgt die ERSATZSTUFE — dieselbe Anfrage auf
         specs.replaces_wattage. Damit erscheint die "LED Tube T8 7-16W/840 G13"
         im Dropdown, aber per Klasse 4 immer hinter den exakten Treffern. */
      if (replace) {
        delete scroll.dataset.techPhase;
        delete scroll.dataset.techPhaseQuery;
        delete scroll.dataset.nativeAutoPages;
      }
      var ersatzPhase = scroll.dataset.techPhase === 'ersatz'
        && scroll.dataset.techPhaseQuery === query;
      var techGate = [];
      if (techSpec && techSpec.technisch && !gateAus) {
        techGate = ersatzPhase
          ? window.LMMTechRank.ersatzFilterParams(techSpec)
          : window.LMMTechRank.filterParams(techSpec);
      }
      /* append statt set (2026-08-13): ersatzFilterParams liefert seit der
         Ersatzklasse MEHRERE replaces_wattage-Werte (50/51/…/55) — Shopify
         ODER-verknuepft wiederholte Filterwerte. Die URL ist je Aufruf frisch,
         append erzeugt also keine Duplikate. */
      techGate.forEach(function (paar) { url.searchParams.append(paar[0], paar[1]); });
      /* Bestseller-Sortierung nur, wenn die Anfrage KEINE Artikelnummer ist.
         Bei einer Identifier-Anfrage entscheidet ausschliesslich der exakte
         Feldtreffer; eine Verkaufssortierung waere dort bedeutungslos und
         wuerde nur fremde Nummerntreffer nach vorn holen. */
      var identAnfrage = window.LMMRelevance && window.LMMRelevance.identifierQuery(query);
      if (!identAnfrage && (!result || result.mode !== 'exact')) url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', 'lmm-predictive-more');
      var response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      if (!scroll.isConnected || !input || input.value.trim() !== query) return;
      /* Ueberholte Kette: Ergebnis verwerfen, bevor es die Liste beruehrt. */
      if (String(scroll.dataset.lmmKette || '0') !== kette) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var payload = doc.querySelector('[data-lmm-more-products]');
      if (!payload) { scroll.dataset.done = '1'; return; }
      /* Fallback-Stufe: liefert die strenge Kandidatenstufe auf Seite 1
         ueberhaupt nichts, wird sie fuer genau diese Query abgeschaltet und der
         Ladevorgang unverengt wiederholt. Erst wenn die vorherige Stufe leer
         ist — nicht vorher. Gemessener Leerfall: 16W/999 G13 -> 0 Treffer. */
      var geliefert = payload.querySelectorAll('[data-lmm-more-product]').length;
      /* In der Ersatzstufe bedeutet "leer" nur: es gibt keine Ersatzprodukte.
         Die strenge Stufe darf dadurch NICHT abgeschaltet werden — sonst
         wuerde die Liste nach guten exakten Treffern ungefiltert geflutet. */
      if (ersatzPhase && geliefert === 0) {
        scroll.dataset.done = '1';
        return;
      }
      if (techGate.length && geliefert === 0 && page === 1) {
        scroll.dataset.techGateAus = query;
        scroll.dataset.done = '0';
        setTimeout(function () { loadNativePage(scroll, 1, replace); }, 0);
        return;
      }
      if (replace) resetNachladungen(list);
      var keys = existingKeys(list);
      var added = 0;
      var grouping = result && result.productGrouping;
      payload.querySelectorAll('[data-lmm-more-product]').forEach(function (node) {
        if (grouping && !productMatchesGrouping(node, grouping)) return;
        var key = productKey(node);
        if (!key || keys.has(key)) return;
        keys.add(key);
        anhaengen(list, node);
        added += 1;
      });
      sortProductList(list);
      hideEmptyNoteIfFilled(scroll, list);
      refreshProductCats(box);
      /* KORREKTURRUNDE 4 (Chris Phase 6): Nach jeder nativen Ladung pruefen,
         ob eine ausdrueckliche Sockelanfrage genug exakte Kandidaten hat —
         sonst EINMAL die kanonische Sockelanfrage ergaenzen (verifiziert,
         dedupliziert). Laeuft dank Query-Guard hoechstens einmal je Eingabe. */
      sockelErgaenzung(scroll);
      var hasNext = payload.dataset.hasNext === 'true';
      scroll.dataset.nextPage = String(page + 1);
      if (!hasNext) {
        /* Strenge Stufe durchgeblaettert -> einmalig auf die Ersatzstufe
           umschalten (ersetzte Leistung statt tatsaechlicher). Danach ist
           Schluss; es gibt keine dritte Stufe. */
        var naechste = (techSpec && techSpec.technisch && !gateAus && !ersatzPhase)
          ? window.LMMTechRank.ersatzFilterParams(techSpec) : [];
        if (naechste.length) {
          scroll.dataset.techPhase = 'ersatz';
          scroll.dataset.techPhaseQuery = query;
          scroll.dataset.done = '0';
          scroll.dataset.nextPage = '1';
          setTimeout(function () { loadNativePage(scroll, 1, false); }, 0);
        } else {
          scroll.dataset.done = '1';
        }
      }
      /* Kandidatenpool-Stufe (siehe Begruendung oben). Sie steht VOR der
         geometrischen Stufe und uebernimmt fuer technisch verengte Anfragen
         das Weiterblaettern vollstaendig — damit laufen nie beide Stufen
         gleichzeitig und es entsteht keine zweite Anfrageserie. Ein
         Query-Wechsel beendet die Kette von selbst: jede Folgeladung
         verwirft ihr Ergebnis oben ueber den Vergleich mit input.value und
         kehrt zurueck, bevor sie hier ankommt. */
      var poolStufe = techGate.length > 0 && !gateAus && !ersatzPhase && !identAnfrage;
      if (poolStufe) {
        /* replace ist der Neustart durch die Komponente: die Liste wurde
           soeben geleert, also faengt auch der Pool wieder bei Seite 1 an —
           auch dann, wenn dieselbe Query erneut eingegeben wurde. */
        if (replace || scroll.dataset.lmmDropPoolQuery !== query) {
          scroll.dataset.lmmDropPoolQuery = query;
          scroll.dataset.lmmDropPoolSeiten = '1';
        }
        var poolGeladen = Number(scroll.dataset.lmmDropPoolSeiten || 1);
        if (hasNext && poolGeladen < 1 + DROP_POOL_SEITEN_MAX) {
          scroll.dataset.lmmDropPool = 'laedt';
          scroll.dataset.lmmDropPoolSeiten = String(poolGeladen + 1);
          ketteFort(scroll, input, query, page + 1, kette);
          return;
        }
        scroll.dataset.lmmDropPool = hasNext ? 'begrenzt' : 'vollstaendig';
      }
      /* KORREKTURRUNDE 4: Auto-Weiterblaettern begrenzen — dieselbe 6-Seiten-
         Grenze wie bei der Collection-Nachladung. Ohne sie blaetterte das
         Dropdown bei "Ersatz fuer 6W E27" die komplette aufgeweichte native
         Trefferliste durch (13+ Seiten, bis zum HTTP 429), weil hart
         ausgeschlossene Karten den Scrollbereich nie fuellen (belegt
         05.08.2026). Der Kunde kann per Scroll weiterhin nachladen. */
      var sichtbarNeu = Array.prototype.filter.call(list.children, function (n) {
        return n instanceof HTMLElement && !n.dataset.lmmTechHidden && n.style.display !== 'none';
      }).length;
      var nativeAuto = Number(scroll.dataset.nativeAutoPages || 0);
      if (sichtbarNeu > 0 && scroll.scrollHeight > scroll.clientHeight + 20) {
        scroll.dataset.nativeAutoPages = '0';
        nativeAuto = 0;
      }
      if (hasNext && (added === 0 || scroll.scrollHeight <= scroll.clientHeight + 20)) {
        if (nativeAuto < 6) {
          scroll.dataset.nativeAutoPages = String(nativeAuto + 1);
          ketteFort(scroll, input, query, page + 1, kette);
        }
      }
    } catch (error) {
      scroll.dataset.error = '1';
      if (window.console) console.warn('[LMM Predictive] Weitere Produkte konnten nicht geladen werden.', error);
    } finally {
      delete scroll.dataset.loading;
      scroll.classList.remove('is-loading');
    }
  }

  /* SOCKEL-ERGAENZUNG im Dropdown (Korrekturrunde 4, Chris Phase 6) — das
     Gegenstueck zur Sockelstufe der Suchseite. Belegt am 05.08.2026: fuer
     "leuchtmittel g9" enthielt der native Kandidatenpool kein einziges
     G9-Leuchtmittel, die native Anfrage "g9" liefert dagegen durchgaengig
     strukturierte G9-Artikel; filter.p.m.specs.base bleibt wirkungslos.
     Grenzen: genau EINE zusaetzliche Seite (lmm-predictive-more), ausgeloest
     nur bei weniger als SOCKEL_MIN sichtbaren Karten, einmal je Eingabe
     (Guard scroll.dataset.sockelQuery); jede Karte wird mit der ORIGINALEN
     Kundenanfrage gegen ALLE harten Bedingungen geprueft und ueber die
     Shopify-Product-ID dedupliziert. */
  var SOCKEL_MIN = 4;

  async function sockelErgaenzung(scroll) {
    if (!(scroll instanceof HTMLElement)) return;
    var box = scroll.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
    var input = box && inputFor(box);
    var query = input ? input.value.trim() : '';
    if (!query || scroll.dataset.sockelQuery === query) return;
    if (!window.LMMTechRank || !window.LMMRelevance) return;
    var analyse = null;
    try { analyse = window.LMMRelevance.analyze(query); } catch (fehler) { return; }
    if (!analyse || analyse.identifier) return;
    var spec = analyse.tech;
    if (!spec || !spec.sockel) return;
    var list = scroll.querySelector('.lmm-predictive__prods');
    var sichtbar = 0;
    if (list) {
      Array.from(list.children).forEach(function (n) {
        if (n instanceof HTMLElement && !n.dataset.lmmTechHidden) sichtbar += 1;
      });
    }
    if (sichtbar >= SOCKEL_MIN) return;
    scroll.dataset.sockelQuery = query;
    try {
      var base = (window.Theme && Theme.routes && Theme.routes.search_url) || '/search';
      var url = previewUrl(base);
      url.searchParams.set('q', spec.sockel);
      url.searchParams.set('type', 'product');
      window.LMMTechRank.filterParams(spec).forEach(function (paar) { url.searchParams.set(paar[0], paar[1]); });
      url.searchParams.set('page', '1');
      url.searchParams.set('section_id', 'lmm-predictive-more');
      var response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      var html = await response.text();
      if (!scroll.isConnected || !input || input.value.trim() !== query) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var payload = doc.querySelector('[data-lmm-more-products]');
      if (!payload) return;
      list = ensureProductList(scroll);
      var keys = existingKeys(list);
      var added = 0;
      payload.querySelectorAll('[data-lmm-more-product]').forEach(function (node) {
        var key = productKey(node);
        if (!key || keys.has(key)) return;
        var v = null;
        try { v = window.LMMRelevance.rank(analyse, relevanzDaten(node)); } catch (fehler) { v = null; }
        /* Verifikation gegen ALLE harten Bedingungen der ORIGINALEN Anfrage:
           nur exakt belegte Sockel ohne jeden Widerspruch. */
        if (!v || v.hart > 0 || v.sockel !== 0) return;
        keys.add(key);
        anhaengen(list, node);
        added += 1;
      });
      if (added) {
        sortProductList(list);
        hideEmptyNoteIfFilled(scroll, list);
      }
    } catch (error) {
      if (window.console) console.warn('[LMM Predictive] Sockel-Ergaenzung konnte nicht geladen werden.', error);
    }
  }

  function loadMore(scroll) {
    if (scroll.dataset.source === 'collection' && scroll.dataset.collectionUrl) {
      if (scroll.dataset.done === '1') return;
      return loadCollectionPage(scroll, Number(scroll.dataset.nextPage || '2'), false);
    }
    return loadNativePage(scroll, Number(scroll.dataset.nextPage || '2'), false);
  }

  function bindInfinite(root) {
    var scroll = root.querySelector('[data-lmm-products-scroll]');
    if (!scroll || scroll.dataset.infiniteBound === '1') return;
    scroll.dataset.infiniteBound = '1';
    scroll.dataset.nextPage = scroll.dataset.nextPage || '1';


    var scheduled = false;
    scroll.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        if (scroll.scrollTop + scroll.clientHeight >= scroll.scrollHeight - 120) loadMore(scroll);
      });
    }, { passive: true });
    requestAnimationFrame(function () {
      if (scroll.scrollHeight <= scroll.clientHeight + 20) loadMore(scroll);
    });
  }

  /* ================ TREFFERBESCHRIFTUNG AM SICHTBAREN ENDZUSTAND ================
     Anlass (Chris, 2026-08-10). Das Dropdown rendert Leermeldung und Statusregion
     serverseitig aus der NATIVEN Trefferzahl. Liefert Shopify null Produkte und
     kommen die Karten erst aus einer LMM-Nachladestufe (technische Schreibweise,
     Familie, Sockel, Ersatz), blieb oben "Keine Treffer ..." stehen, waehrend
     darunter korrekte Produkte lagen — live gemessen am 10.08.2026:
       13w840             0 nativ -> 23 sichtbare Karten, Leermeldung sichtbar
       Ersatz fuer 6W E27 0 nativ ->  2 sichtbare Karten, Leermeldung sichtbar
       g9 fassung         0 nativ ->  1 sichtbare Karte,  Leermeldung sichtbar
     Umgekehrt behauptete die Statusregion bei "Philips TUV 11W" 3 Treffer,
     obwohl 24 Karten sichtbar waren.

     Regel: Die Beschriftung nennt ausschliesslich den Endzustand NACH allen
     Nachladestufen, harten Ausschluessen und der Deduplizierung. Sie behauptet
     KEINE Gesamtsumme aus Shopify — die Liste ist paginiert — sondern zaehlt die
     tatsaechlich sichtbaren Karten ("N passende Treffer").

     Bleiben null Karten sichtbar, bleibt die ehrliche Nulltreffer-Meldung stehen;
     zurueckgeholt wird sie nur, wenn genau diese Funktion sie vorher versteckt hat
     (data-lmm-count-hidden) — die Intent-/Route-Panels blenden dieselbe Meldung
     bewusst aus und duerfen davon nicht ueberstimmt werden.

     Keine zusaetzliche Suchanfrage. Keine Observer-Schleife: geschrieben wird nur
     bei echter Aenderung, das hidden-Attribut sieht der Komponenten-Observer
     ohnehin nicht (er reagiert allein auf childList). */
  function sichtbareKarten(box) {
    var zahl = 0;
    box.querySelectorAll('li.predictive-search-results__card[data-lmm-product-id]').forEach(function (node) {
      if (node.dataset.lmmTechHidden) return;
      if (node.hasAttribute('hidden')) return;
      if (node.style.display === 'none') return;
      zahl += 1;
    });
    return zahl;
  }

  function trefferStatus(box) {
    if (!(box instanceof HTMLElement)) return;
    var inner = box.querySelector('[data-search-results]') || box;
    var input = inputFor(box);
    var query = input ? String(input.value || '').trim() : '';
    if (!query) return;
    var zahl = sichtbareKarten(box);
    /* Reine Artikelnummern-/EAN-Anfragen echoen den Suchbegriff bewusst nicht —
       dieselbe Regel wie das serverseitige identifier_query_flag, damit die
       Beschriftung mit und ohne Treffer gleich formuliert ist. */
    var identNote = inner.querySelector('[data-lmm-ident-none]');
    var identifier = !!(identNote && !identNote.hasAttribute('hidden'));
    if (!identifier && window.LMMRelevance && typeof window.LMMRelevance.analyze === 'function') {
      try { identifier = !!window.LMMRelevance.analyze(query).identifier; } catch (fehler) { /* Analyse optional */ }
    }
    var zusatz = identifier ? '' : ' f\u00FCr \u201E' + query + '\u201C';

    var leer = inner.querySelector('.lmm-predictive__none:not(.lmm-predictive__none--ident)');
    if (leer) {
      /* Uebernommen wird die Meldung nur, wenn sie sichtbar ist oder bereits von
         hier stammt. Eine von der Intent-Engine bewusst ausgeblendete Meldung
         (Route-/Ambiguous-Panel) bleibt unangetastet.
         Zusaetzlich inline display:none, weil setNativeVisible() der Intent-Engine
         bei mode=native in JEDEM Patchzyklus nur das hidden-ATTRIBUT entfernt —
         das inline Style ueberlebt das und macht die Reihenfolge der beiden
         Debounces (8 ms Intent, 14 ms Layout) irrelevant. */
      if (zahl > 0) {
        if (!leer.hasAttribute('hidden') || leer.hasAttribute('data-lmm-count-hidden')) {
          leer.setAttribute('data-lmm-count-hidden', '');
          leer.setAttribute('hidden', '');
          if (leer.style.display !== 'none') leer.style.display = 'none';
        }
      } else if (leer.hasAttribute('data-lmm-count-hidden')) {
        leer.removeAttribute('data-lmm-count-hidden');
        leer.removeAttribute('hidden');
        leer.style.removeProperty('display');
      }
    }

    var status = inner.querySelector('.visually-hidden[role="status"]');
    if (!status) return;
    var exactScroll = inner.querySelector('[data-lmm-products-scroll]');
    var exactState = exactScroll && exactScroll.dataset.lmmExactState;
    var text = exactState === 'loading' ? 'Artikel wird gesucht'
      : exactState === 'unavailable' ? 'Artikelsuche vorübergehend nicht verfügbar'
      : exactState === 'ambiguous' ? 'Mehrdeutige Artikelnummer'
      : zahl === 0
      ? 'Keine Treffer' + zusatz
      : (zahl === 1 ? '1 passender Treffer' + zusatz : zahl + ' passende Treffer' + zusatz);
    if (status.textContent.replace(/\s+/g, ' ').trim() === text) return;
    status.textContent = text;
  }

  function integrate(box) {
    if (!(box instanceof HTMLElement)) return;
    var split = box.querySelector('[data-lmm-predictive-split]');
    if (!split) return;
    var input = inputFor(box);
    var query = input ? input.value.trim() : '';
    if (!query) return;

    initExactCategoryData();

    var productsPane = split.querySelector('.lmm-predictive__sec--prods');
    var scroll = split.querySelector('[data-lmm-products-scroll]');
    var categoriesPane = split.querySelector('[data-lmm-categories-slot]');
    var nativeCategories = categoriesPane && categoriesPane.querySelector('[data-lmm-native-categories]');
    var intentPanel = box.querySelector('[data-lmm-intent-panel]');
    var result = intentResult(query);

    if (!intentPanel && result && result.categories && result.categories.length &&
        window.LMMSearchIntent && typeof window.LMMSearchIntent.panelMarkup === 'function') {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = window.LMMSearchIntent.panelMarkup(result);
      intentPanel = wrapper.firstElementChild;
    }

    if (productsPane) productsPane.removeAttribute('hidden');
    box.querySelectorAll('.lmm-predictive__all').forEach(function (element) { element.removeAttribute('hidden'); });

    if (categoriesPane) {
      if (intentPanel) {
        if (intentPanel.parentElement !== categoriesPane) categoriesPane.appendChild(intentPanel);
        intentPanel.setAttribute('data-lmm-layout-integrated', '');
        categoriesPane.removeAttribute('hidden');
        if (nativeCategories) nativeCategories.setAttribute('hidden', '');
      } else if (nativeCategories) {
        nativeCategories.removeAttribute('hidden');
        var hasNative = !!nativeCategories.querySelector('.lmm-predictive__cat');
        if (hasNative) categoriesPane.removeAttribute('hidden'); else categoriesPane.setAttribute('hidden', '');
      }
    }

    if (scroll) {
      if (window.LMMExactProductSearch && window.LMMExactProductSearch.parse(query)) {
        var exactList = ensureProductList(scroll);
        if (categoriesPane) categoriesPane.setAttribute('hidden', '');
        scroll.dataset.query = query; scroll.dataset.source = 'exact'; scroll.dataset.done = '1';
        window.LMMExactProductSearch.dropdown(box, scroll, exactList, query, function () {
          sortProductList(exactList); trefferStatus(box);
        });
        return;
      }
      scroll.dataset.intentMode = result && result.mode ? result.mode : 'native';
      /* Chris Phase 5: Eine Collection-Route ersetzt die native Produktsuche
         nur noch bei einem reinen, breiten Kategorie-Intent. Bei jeder Anfrage
         mit Marke, Serie, Artikelnummer oder technischem Wert bleibt der Kunde
         in der nativen Suche — die Kategorie steht weiterhin rechts.
         Zusammen mit resetNachladungen() (part-3) ist damit ausgeschlossen,
         dass ein nativer Rang-1-Treffer durch eine fehlende manuelle
         Collection-Zuordnung verschwindet.
         ERWEITERT 2026-08-13 (Chris Phase 7/17): Serienfamilie mit
         vollstaendig als Filter mitreisender Technik ("Dulux L 36W") laedt
         wieder die Collection — zentrale Regel LMMRelevance.routingErlaubt,
         identisch mit Router und Enter-Pfad. */
      var kategorieIntent = !window.LMMRelevance
        || (typeof window.LMMRelevance.routingErlaubt === 'function'
          ? window.LMMRelevance.routingErlaubt(query, result)
          : window.LMMRelevance.reinerKategorieIntent(query));
      scroll.dataset.lmmRouting = kategorieIntent ? 'kategorie' : 'produktsuche';
      var collectionUrl = kategorieIntent ? targetCollectionUrl(result) : null;
      if (collectionUrl) {
        var canonical = collectionUrl.pathname + collectionUrl.search;
        var listIsEmpty = !scroll.querySelector('.lmm-predictive__prod');
        if (scroll.dataset.collectionPrimaryUrl !== canonical || scroll.dataset.query !== query || scroll.dataset.source !== 'collection' ||
            (listIsEmpty && !scroll.dataset.loading)) {
          scroll.scrollTop = 0;
          scroll.dataset.collectionPrimaryUrl = canonical;
          scroll.dataset.collectionUrl = canonical;
          /* Generischer Fallback: Läuft eine GEFILTERTE Collection-Route leer (z. B.
             wattage=36 matcht die Filterwerte nicht), wird dieselbe Collection ohne
             Filter nachgeladen — loadCollectionPage filtert in der Fallback-Phase
             per Watt-Titeltext nach. Resolver-eigene Fallbacks haben Vorrang. */
          var fallbackUrl = result && result.collectionFallbackUrl ? String(result.collectionFallbackUrl) : '';
          if (!fallbackUrl && collectionUrl.search.indexOf('filter.') !== -1) fallbackUrl = collectionUrl.pathname;
          scroll.dataset.collectionFallbackUrl = fallbackUrl;
          scroll.dataset.collectionPhase = 'primary';
          scroll.dataset.query = query;
          scroll.dataset.source = 'collection';
          scroll.dataset.nextPage = '2';
          scroll.dataset.done = '0';
          scroll.dataset.loading = 'scheduled';
          var scheduledQuery = query;
          setTimeout(function () {
            if (!scroll.isConnected) { patchAll(); return; }
            var scheduledBox = scroll.closest('[ref="predictiveSearchResults"], .lmm-predictive__results');
            var scheduledInput = scheduledBox && inputFor(scheduledBox);
            if (!scheduledInput || scheduledInput.value.trim() !== scheduledQuery) { delete scroll.dataset.loading; return; }
            delete scroll.dataset.loading;
            loadCollectionPage(scroll, 1, true);
          }, 120);
        }
      } else {
        delete scroll.dataset.collectionUrl;
        delete scroll.dataset.collectionPrimaryUrl;
        delete scroll.dataset.collectionFallbackUrl;
        delete scroll.dataset.collectionPhase;
        if (scroll.dataset.query !== query || scroll.dataset.source !== 'native') {
          scroll.scrollTop = 0;
          scroll.dataset.query = query;
          scroll.dataset.source = 'native';
          scroll.dataset.nextPage = '2';
          scroll.dataset.done = '0';
          loadNativePage(scroll, 1, true);
        } else {
          sortProductList(scroll.querySelector('.lmm-predictive__prods'));
        }
      }
    }

    sortAllVisible(split);
    refreshProductCats(box);
    bindInfinite(split);
    trefferStatus(box);
    ensureIndexPages(EAGER_INDEX_PAGES).then(function () { sortVisibleProductsOnly(split); refreshProductCats(box); trefferStatus(box); startIdleIndexLoad(); });
  }

  function categoryLinkFromEvent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return null;
    var link = target.closest('.lmm-intent-category__link, .lmm-predictive__cat-a');
    if (!link || !link.closest('.lmm-predictive__categories-pane')) return null;
    return link;
  }

  function navigateCategory(event) {
    var link = categoryLinkFromEvent(event);
    if (!link) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    window.location.assign(link.href || href);
  }

  function patchAll() {
    clearTimeout(timer);
    timer = window.setTimeout(function () {
      document.querySelectorAll('[ref="predictiveSearchResults"], .lmm-predictive__results').forEach(integrate);
    }, 14);
  }

  var observedPredictiveComponents = new WeakSet();
  function observePredictiveComponents() {
    document.querySelectorAll('predictive-search-component').forEach(function (component) {
      if (observedPredictiveComponents.has(component)) return;
      observedPredictiveComponents.add(component);
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (mutation) {
          return mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length);
        });
        if (relevant) patchAll();
      }).observe(component, { childList:true, subtree:true });
    });
  }

  function bootPredictiveLayout() {
    observePredictiveComponents();
    patchAll();
  }

  /* Alternativen-Chips in der Produktzeile: die Zeile selbst ist ein <a>, die Chips sind
     deshalb spans mit data-lmm-alt-url (kein verschachtelter Link). Capture-Delegation
     navigiert bei Klick sowie Enter/Leertaste und stoppt das Durchreichen an den
     umgebenden Produktlink. */
  function navigateAltChip(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var chip = target.closest('[data-lmm-alt-url]');
    if (!chip) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (event.type === 'click' && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    var url = chip.getAttribute('data-lmm-alt-url');
    if (!url) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    window.location.assign(url);
  }
  document.addEventListener('click', navigateAltChip, true);
  document.addEventListener('keydown', navigateAltChip, true);

  restoreIndexCache();
  initExactCategoryData();
  document.addEventListener('click', navigateCategory, true);
  document.addEventListener('input', function (event) {
    if (event.target instanceof HTMLInputElement && event.target.name === 'q') {
      observePredictiveComponents();
      patchAll();
    }
  }, true);
  document.addEventListener('focusin', function (event) {
    if (event.target instanceof HTMLInputElement && event.target.name === 'q') {
      observePredictiveComponents();
      patchAll();
    }
  }, true);
  document.addEventListener('lmm:search-intent-ready', function () {
    exactCategoryDataReady = false;
    initExactCategoryData();
    observePredictiveComponents();
    patchAll();
  });
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bootPredictiveLayout, { once:true })
    : bootPredictiveLayout();
})();

